import { render, staticRenderFns } from "./PatientDetailsCard.vue?vue&type=template&id=54ac29c0"
import script from "./PatientDetailsCard.vue?vue&type=script&lang=js"
export * from "./PatientDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports